export const tools = [
  {
    slug: 'password-generator',
    name: 'Password Generator',
    category: 'Security & Identity',
    description: 'Gere senhas fortes com regras simples e resultado copiável.',
    status: 'available',
  },
  {
    slug: 'base64-converter',
    name: 'Base64 Encoder / Decoder',
    category: 'Encoding & Data',
    description: 'Converta texto para Base64 e volte com rapidez.',
    status: 'available',
  },
  {
    slug: 'guid-generator',
    name: 'UUID Generator',
    category: 'Security & Identity',
    description: 'Gere UUIDs para testes, mocks e integrações.',
    status: 'available',
  },
  {
    slug: 'string-utilities',
    name: 'Text Manipulator',
    category: 'Text & Formatting',
    description: 'Transforme, normalize e inspecione textos rapidamente.',
    status: 'available',
  },
  {
    slug: 'json-formatter',
    name: 'JSON Formatter / Validator',
    category: 'Encoding & Data',
    description: 'Formate, valide e compacte JSON sem sair do navegador.',
    status: 'available',
  },
  {
    slug: 'jwt-decoder',
    name: 'JWT Decoder',
    category: 'Security & Identity',
    description: 'Leia header e payload de tokens JWT com clareza.',
    status: 'available',
  },
  {
    slug: 'url-encode-decode',
    name: 'URL Encode / Decode',
    category: 'Encoding & Data',
    description: 'Encode e decode parâmetros e strings de URL.',
    status: 'planned',
  },
  {
    slug: 'hash-generator',
    name: 'Hash Generator',
    category: 'Security & Identity',
    description: 'Gere hashes para testes, verificações e integrações.',
    status: 'planned',
  },
  {
    slug: 'timestamp-converter',
    name: 'Timestamp Converter',
    category: 'Time & Utilities',
    description: 'Converta datas e unix timestamps sem abrir outra ferramenta.',
    status: 'planned',
  },
];

export const featuredTools = [
  'password-generator',
  'json-formatter',
  'guid-generator',
  'jwt-decoder',
  'string-utilities',
  'hash-generator',
];
